import { defineComponent as _defineComponent } from 'vue'
import AppHeader from "@/components/common/AppHeader.vue";
import AppSidebar from "@/components/common/AppSidebar.vue";
import { computed } from "vue";
import { useUserStore } from "@/store/user";
import { useUIStore } from "@/store/ui";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props, { expose }) {
  expose();

const { collapsed } = storeToRefs(useUIStore());
const route = useRoute();

const userStore = useUserStore();
const isFullPageLayout = computed(
  () => !userStore.accessToken || route.meta.fullPage
);

const __returned__ = { collapsed, route, userStore, isFullPageLayout, AppHeader, AppSidebar, computed, useUserStore, useUIStore, storeToRefs, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})